import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Headset: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 20, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 20) / 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99975 0C6.07134 0 2.75996 2.68257 2.11397 6.25568H1.53992C0.6868 6.25568 0 6.9425 0 7.79564V12.2051C0 13.0582 0.6868 13.745 1.53992 13.745H2.27814C3.13125 13.745 3.81805 13.0582 3.81805 12.2051V7.53185C3.81805 4.38566 6.52763 1.81807 10.0005 1.81807C13.4734 1.81807 16.1829 4.38566 16.1829 7.53185V12.4689C16.1829 15.615 13.4734 18.1817 10.0005 18.1817C9.49835 18.1817 9.09136 18.5888 9.09145 19.091C9.0915 19.593 9.49843 20 10.0005 20C13.929 20 17.2403 17.318 17.8862 13.745H18.4601C19.3132 13.745 20 13.0582 20 12.2051V7.79564C20 6.9425 19.3132 6.25568 18.4601 6.25568H17.8862C17.2403 2.68257 13.929 0 10.0005 0H9.99975ZM8.27944 13.2337C7.77492 13.2337 7.35124 13.6572 7.52197 14.1293C7.88837 15.1432 8.85935 15.8678 9.99953 15.8678C11.1398 15.8678 12.1109 15.1432 12.4773 14.1293C12.648 13.6572 12.2244 13.2337 11.7198 13.2337H8.27944Z"
        fill="currentColor"
      />
    </svg>
  )
})

Headset.displayName = 'Headset'
